export default {
  path: "/inventory",
  redirect: "/inventory/jd",
  meta: {
    icon: "ri:archive-stack-line",
    showLink: true,
    title: "库存维护",
    rank: 60
  },
  children: [
    {
      path: "/inventory/jd",
      name: "InventoryJd",
      component: () => import("@/views/inventory/jd/index.vue"),
      meta: {
        title: "京东库存维护",
        showParent: true,
        icon: "ri:store-2-line"
      }
    }
  ]
} satisfies RouteConfigsTable;
